/**
 * Colunas — fonte Produção (volumetria) / TB02117 (complementar ao parque locado).
 */

import { CalendarDays, BarChart3 } from 'lucide-react';

export const PRODUCAO_MES_COLUMN_ID = 'mes';

export const PRODUCAO_COUNTER_COLUMN_IDS = [
  'prodA4Pb',
  'prodA4Cor',
  'prodDig',
  'prodA3Pb',
  'prodA3Cor',
];

export const PRODUCAO_MED_COLUMN_IDS = [
  'medAtualA4Pb',
  'medAtualA4Cor',
  'medAtualDig',
  'medAtualA3Pb',
  'medAtualA3Cor',
];

export const PRODUCAO_VOLUMETRIA_METRIC_COLUMN_IDS = [
  ...PRODUCAO_COUNTER_COLUMN_IDS,
  ...PRODUCAO_MED_COLUMN_IDS,
];

export const PRODUCAO_VOLUMETRIA_COLUMN_IDS = [
  PRODUCAO_MES_COLUMN_ID,
  ...PRODUCAO_VOLUMETRIA_METRIC_COLUMN_IDS,
  'medAtualA4Pb',
  'medAtualA4Cor',
  'medAtualDig',
  'medAtualA3Pb',
  'medAtualA3Cor',
];

export const FILTER_EXCLUDED_IDS_PRODUCAO = [...PRODUCAO_VOLUMETRIA_COLUMN_IDS];

export const COLUMNS_CONFIG_PRODUCAO = [
  { id: 'mes', label: 'Mês', icon: CalendarDays },
  { id: 'prodA4Pb', label: 'Prod. A4 P&B', icon: BarChart3 },
  { id: 'prodA4Cor', label: 'Prod. A4 Cor', icon: BarChart3 },
  { id: 'prodDig', label: 'Prod. Dig.', icon: BarChart3 },
  { id: 'prodA3Pb', label: 'Prod. A3 P&B', icon: BarChart3 },
  { id: 'prodA3Cor', label: 'Prod. A3 Cor', icon: BarChart3 },
  { id: 'medAtualA4Pb', label: 'Med. Atual A4 P&B', icon: BarChart3 },
  { id: 'medAtualA4Cor', label: 'Med. Atual A4 Cor', icon: BarChart3 },
  { id: 'medAtualDig', label: 'Med. Atual Dig.', icon: BarChart3 },
  { id: 'medAtualA3Pb', label: 'Med. Atual A3 P&B', icon: BarChart3 },
  { id: 'medAtualA3Cor', label: 'Med. Atual A3 Cor', icon: BarChart3 },
];
